import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 9846C329-0B20-40A4-9362-D350C063F53C
 * name microsoft-dynamics-365
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-dynamics-365.svg
 * tags
 * - Brand / Logo 
 */
export const MicrosoftDynamics365Icon = createSvgIcon(<><path d="M6,2L17.25,8.5L13.5,11.5L6,8V2M6,9L9.5,11.25L6,22L18,9V15L6,22V9Z" /></>, 'MicrosoftDynamics365Icon');
export default MicrosoftDynamics365Icon